import React from "react";
import { Link } from "react-router-dom";

const Logo = () => (
  <span className="text-base font-extrabold tracking-tight">
    <span style={{ color: "#ffffff" }}>Casino</span>
    <span style={{ color: "var(--cp-green)" }}>Picks</span>
  </span>
);

const Footer = () => {
  return (
    <footer
      className="mt-16"
      style={{ borderTop: "1px solid var(--cp-border)" }}
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 py-8 md:flex-row md:justify-between">
        <Link to="/">
          <Logo />
        </Link>

        <nav className="flex flex-wrap items-center justify-center gap-6">
          <Link
            to="/"
            className="text-sm transition-colors hover:text-white"
            style={{ color: "var(--cp-muted)" }}
          >
            Top Picks
          </Link>
          <Link
            to="/about"
            className="text-sm transition-colors hover:text-white"
            style={{ color: "var(--cp-muted)" }}
          >
            About
          </Link>
          <Link
            to="/contact"
            className="text-sm transition-colors hover:text-white"
            style={{ color: "var(--cp-muted)" }}
          >
            Contact
          </Link>
          <span
            className="rounded-md border px-2 py-0.5 text-xs font-semibold"
            style={{ borderColor: "var(--cp-border)", color: "var(--cp-muted)" }}
          >
            18+
          </span>
        </nav>

        <p className="text-xs" style={{ color: "var(--cp-muted)" }}>
          © 2026 CasinoPicks. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
